/**
 * Gateway experiments are admin-only unless a role is granted
 * `drop_generator.experiments` (user, 14/10/2026: "hide it for the users —
 * everything has to be visible for admin"). Only the screens hide: a running
 * experiment still reserves its drops, and the endpoints sit on the same
 * permission.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenEventRow } from '@trafficpulse/shared';

import { useAuth } from '@/providers/AuthProvider';

export const EXPERIMENTS_PERMISSION = 'drop_generator.experiments';

export function useCanSeeExperiments(): boolean {
  return useAuth().hasPermission(EXPERIMENTS_PERMISSION);
}

/** The feed without the experiment lines for someone who cannot see experiments. */
export function useVisibleEvents(events: DropGenEventRow[] | undefined): DropGenEventRow[] | undefined {
  const canSee = useCanSeeExperiments();
  if (canSee || !events) return events;
  return events.filter((e) => !e.event.startsWith('experiment_'));
}
